var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageLayout',[_c('GnbLeftView'),_c('div',{attrs:{"id":"outer-wrap"}},[_c('LeftMenu'),_c('SubContentTemplate',{scopedSlots:_vm._u([{key:"body",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }